import { AppThunk } from "../../thunks";
import { getUserDataAPI, postCreateDependantAPI, putEditDependantAPI, postUserAppointmentAPI , deleteUserDependantAPI} from "../../services/restcall";
import { toggleLoadingIndicator } from "../system/actions";
import { MessageResponse } from "../system/types";
import { setMessageResponse } from "../system/actions";
import { Dependant, DependantRequest, UserDataResponse, PatientRequest } from "./types";
import { ApiResponse } from "../../services/types";
import moment from 'moment';

export const getUserData = (): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const responseData: ApiResponse = await getUserDataAPI();
    const apiResponse : ApiResponse = responseData
    const userData: UserDataResponse = responseData.Response;
    if(responseData.Error !== null)
    {
        const errorResponse=responseData.Error;
        if (errorResponse.status >= 400 && errorResponse !== null) {
            const message : MessageResponse = {
                code: errorResponse.status,
                message: errorResponse.status === 403 ? ["Información no disponible"] : [errorResponse.errors.error[0]]
            };
            dispatch(setMessageResponse(message));
        }
    }
    else
    {
        let dependantsWithBirtdate = userData.dependants?.map<Dependant>((item) => ({
                ...item,
                birthdate: new Date(item.birthdate === null ? '1900-01-01' : moment(moment(item.birthdate).utc().format("YYYY-MM-DD")).toDate()),
                relationship : item.relationship.charAt(0).toUpperCase() + item.relationship.slice(1)
            }
        ));
        userData.dependants = dependantsWithBirtdate;
        apiResponse.Response = userData;
        dispatch(setMessageResponse(null));
    }

    dispatch(toggleLoadingIndicator(false));
    return apiResponse;
 };


export const putEditDependant = (dependant: Dependant): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const dependantRequest: DependantRequest= {
        identification: dependant.identification,
        typeIdentification: dependant.typeIdentification,
        firstName: dependant.firstName,
        lastName: dependant.lastName,
        relationship: dependant.relationship,
        birthdate: moment(dependant.birthdate === null? '1900-01-01' : dependant.birthdate).format("YYYY-MM-DD"),
        gender: dependant.gender
    }
    const responseData = await putEditDependantAPI(dependantRequest);
    if(responseData.Error !== null)
    {
        const errorResponse=responseData.Error;
        if (responseData.Error.status >= 400 && errorResponse !== null) {
            const message : MessageResponse = {
                code: responseData.Error.status,
                message: [responseData.Error.errors.error[0]]
            };
            dispatch(setMessageResponse(message));
        }
    }
    else
    {
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};


export const postCreateDependant = (dependant: Dependant): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const dependantRequest: DependantRequest= {
        identification: dependant.identification,
        typeIdentification: dependant.typeIdentification,
        firstName: dependant.firstName,
        lastName: dependant.lastName,
        relationship: dependant.relationship,
        birthdate: moment(dependant.birthdate === null? '1900-01-01' : dependant.birthdate).format("YYYY-MM-DD"),
        gender: dependant.gender
    }
    const responseData = await postCreateDependantAPI(dependantRequest);
    if(responseData.Error !== null)
    {
        const errorResponse=responseData.Error;
        if (errorResponse.status >= 400 && errorResponse !== null) {
            const message : MessageResponse = {
                code: errorResponse.status,
                message: [errorResponse.errors.error[0]]
            };
            dispatch(setMessageResponse(message));
        }
    }
    else
    {
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};
export const postUserAppointment = (patient: PatientRequest ): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const responseData = await postUserAppointmentAPI(patient);
    if(responseData.Error !== null)
    {
        const errorResponse=responseData.Error;
        if (errorResponse.status >= 400 && errorResponse !== null) {
            const message : MessageResponse = {
                code: errorResponse.status,
                message: [errorResponse.errors.error[0]]
            };
            dispatch(setMessageResponse(message));
        }
    }
    else
    {
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};

export const deleteUserDependant = (identification: string ): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const responseData = await deleteUserDependantAPI(identification);
    if(responseData.Error !== null)
    {
        const errorResponse=responseData.Error;
        if (errorResponse.status >= 400 && errorResponse !== null) {
            const message : MessageResponse = {
                code: errorResponse.status,
                message: [errorResponse.errors.error[0]]
            };
            dispatch(setMessageResponse(message));
        }
    }
    else
    {
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};